import React from 'react'
import {  validateFormById } from '../../../shared/formValidation'
import ExpansionPanel from '../expandPanel/ExpansionPanel'
import './bonusForm.css'


export const BonForm = ({
    formId,
    children,
    renderToolBar = null,
    renderNotation = null,
    renderTools = null,
    className = null,
    style = {
        width: '100%',
        marginLeft: '10px',
        marginTop: '15px',
    },
}) => {
    const withToolbar = renderToolBar != null;
    const _style = withToolbar
        ? {
            ...style,
            marginLeft: '2px',
            marginTop: 'none',
        }
        : style;

    return (
        <div
            style={_style}
            className={className}
        >
            {withToolbar && renderToolBar()}
            {withToolbar && renderTools != null && renderTools()}
            <form id={formId}>
                {
                    children
                }
            </form>
            {renderNotation != null && renderNotation()}
        </div>
    );
}

BonForm.ExpansionPanel = ({
    children,
    label = "",
    formId = null,
    tooltip = null,
    className = null,
    expandFunc = null,
    validate = true,
    onExpand = null
}) => {
    const isExpanded = expandFunc == null ? false : expandFunc(formId);

    const handleExpandChange = () => {
        if (validate && isExpanded && formId != null) {
            if (validateFormById('#' + formId)) {
                handleExpand();
            }
            return;
        }
        
        handleExpand();
    }

    const handleExpand = () => {
        if (onExpand != null) {
            onExpand(formId);
        }
    }

    return (
        <ExpansionPanel
            className={className}
            nameId={formId}
            label={label}
            expanded={isExpanded}
            onChange={handleExpandChange}
            tooltip={tooltip}
        >
            {
                children
            }
        </ExpansionPanel>
    );
}

export default BonForm;